import { makeAutoObservable } from "mobx";
import { BehaviorSubject } from "rxjs";

export const isLoading$ = new BehaviorSubject<boolean>(false);
export const openMenu$ = new BehaviorSubject<boolean>(false);
export const pageTitle$ = new BehaviorSubject<string>("");

export const path$ = new BehaviorSubject<Location | null>(null);

export interface IMenuItem {
  link: string | null;
  text: string;
  icon?: string | null;
  isSubItem: boolean;
  menuItem?: IMenuItem[] | null;
}



export interface Error {
  code: string;
  error: any;
  message: string;
}

class AppStore {
  private drawer: boolean;
  private loading: boolean;
  private pageTitle: string = "";
  private error: Error | any;

  private menuItemList: IMenuItem[] = [];

  constructor() {
    this.drawer = true;
    this.loading = false;
    this.error = {};
    makeAutoObservable(this);
  }

  public setLoading(loading: boolean): void {
    this.loading = loading;
  }

  public getLoading = (): boolean => this.loading;

  public setError(error: any): void {
    this.error = error;
  }

  public getError = (): any => this.error;

  public setDrawer(drawer: boolean): void {
    this.drawer = drawer;
  }

  public getDrawer(): boolean {
    return this.drawer;
  }

  get uplodUrl(): string {
    return `${process.env.REACT_APP_IMAGE_BASE_URL}`;
  }

  public setPageTitle(title: string): void {
    this.pageTitle = title
  }

  get getPageTitle(): string {
    return this.pageTitle;
  }
}

const appStore = new AppStore();

export { appStore };
